/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

/** @see backend/nexus/modules/Authentication/Enums/OrganisationHeadcount.php */
export const organisationHeadcount = {
	'1-10': '1-10',
	'11-50': '11-50',
	'51-200': '51-200',
	'201-500': '201-500',
	'501-1000': '501-1000',
	'1000+': '1000+',
} as const

/** @see backend/nexus/modules/Authentication/Enums/OrganisationHeadcount.php */
export type OrganisationHeadcount = (typeof organisationHeadcount)[keyof typeof organisationHeadcount]
